import { gql } from '@apollo/client';

export default gql`
  mutation updateArchive(
    $_id: String
    $title: String
    $titleAr: String
    $desc: String
    $category: String
    $subcategory: String
    $filename: String
    $filetype: String
    $onlinename: String
    $url: String
    $size: Float
    $issueDate: Date
    $expiryDate: Date
    $refNo: String
    $supplierId: String
    $customerId: String
    $employeeId: String
    $departmentId: String
    $tags: [String]
    $notes: String
    $status: String
  ) {
    updateArchive(
      _id: $_id
      title: $title
      titleAr: $titleAr
      desc: $desc
      category: $category
      subcategory: $subcategory
      filename: $filename
      filetype: $filetype
      onlinename: $onlinename
      url: $url
      size: $size
      issueDate: $issueDate
      expiryDate: $expiryDate
      refNo: $refNo
      supplierId: $supplierId
      customerId: $customerId
      employeeId: $employeeId
      departmentId: $departmentId
      tags: $tags
      notes: $notes
      status: $status
    ) {
      ok
      error
      data
    }
  }
`;
